// extracted by mini-css-extract-plugin
export default {"powerSavings":"List_powerSavings__AuioB"};